import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';

const ChatInput = forwardRef(({ onSend, disabled, onFileSelect, selectedFiles }, ref) => {
    const [message, setMessage] = useState('');
    const inputRef = useRef(null);

    // Expose focus method to parent
    useImperativeHandle(ref, () => ({
        focus: () => inputRef.current?.focus()
    }));

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!message.trim() || disabled) return;
        onSend(message);
        setMessage('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    return (
        <div className="clarence-input-container">
            {selectedFiles && selectedFiles.length > 0 && (
                <div className="clarence-selected-files">
                    {selectedFiles.map((file, idx) => (
                        <div key={idx} className="selected-file-chip">
                            <span>{file.split('/').pop()}</span>
                            <button onClick={() => onFileSelect(selectedFiles.filter((_, i) => i !== idx))}>×</button>
                        </div>
                    ))}
                </div>
            )}
            <form className="clarence-input-form" onSubmit={handleSubmit}>
                <textarea
                    ref={inputRef}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Ask Clarence about your documents..."
                    disabled={disabled}
                    rows={1}
                    className="clarence-input"
                />
                <button type="submit" className="clarence-send-btn" disabled={disabled || !message.trim()}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </form>
        </div>
    );
});

export default ChatInput;
